export function rebrandingSessionsToWebinarsPlus(originalValue = '', rebrandValue = '') {
  return window.newBillingConfig?.sessionToWebinarPlusRename ? rebrandValue : originalValue;
}
